"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Twitter = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: 24, viewBox: '0 0 24 24', width: 24, xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("title", null, "Twitter Icon"),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("path", { d: 'M8.29 20c7.547 0 11.675-6.156 11.675-11.495 0-.175 0-.349-.012-.522A8.267 8.267 0 0 0 22 5.892a8.259 8.259 0 0 1-2.356.635 4.065 4.065 0 0 0 1.804-2.234 8.287 8.287 0 0 1-2.606.98 4.153 4.153 0 0 0-5.806-.175 4.007 4.007 0 0 0-1.187 3.86 11.71 11.71 0 0 1-8.456-4.221 4.005 4.005 0 0 0 1.27 5.393A4.127 4.127 0 0 1 2.8 9.624v.052c0 1.923 1.378 3.579 3.292 3.96a4.168 4.168 0 0 1-1.852.069c.537 1.646 2.078 2.774 3.833 2.806A8.316 8.316 0 0 1 2 18.186a11.759 11.759 0 0 0 6.29 1.811', fill: '#464650' }),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = Twitter;
